import { createFileRoute, notFound } from '@tanstack/react-router';
import { lazyScreen } from '@/shared/screen';

// /dev/produtos-conta (só dev): fora do DEV a rota não existe e a página não entra no bundle.
export const Route = createFileRoute('/dev/produtos-conta/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound é o contrato do Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'default') : () => null,
});
